module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Katarzyna Pilarz","short_name":"kpilarz","start_url":"/","background_color":"#F8F8F8","theme_color":"#1E6DB6","display":"standalone","icon":"src/assets/images/favicon.png","cache_busting_mode":"none","icons":[{"src":"src/assets/images/maskable_icon_x512.png","sizes":"512x512","type":"image/png","purpose":"any maskable"},{"src":"src/assets/images/maskable_icon_x192.png","sizes":"192x192","type":"image/png","purpose":"any maskable"}],"legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
